import { render, staticRenderFns } from "./MediaGroup.vue?vue&type=template&id=d8a11488&scoped=true&"
import script from "./MediaGroup.vue?vue&type=script&lang=js&"
export * from "./MediaGroup.vue?vue&type=script&lang=js&"
import style0 from "./MediaGroup.vue?vue&type=style&index=0&id=d8a11488&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a11488",
  null
  
)

export default component.exports